import { Kaggle } from "@kaggle/sdk";

/** Guard for deep Draft validation. */
export function validateDraft(draft: Kaggle.Sdk.Kernels.Models.KernelDraft) {
  // The following draft fields must be present at runtime.
  if (!draft.blob || !draft.blob.settings || !draft.blob.source) {
    throw new Error(`Draft is corrupted: ${JSON.stringify(draft)}`);
  }

  const source = draft.blob.source;

  return {
    ...draft,
    blob: {
      ...draft.blob,
      settings: {
        ...draft.blob.settings,
      },
      source,
    },
  };
}
